import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { tariffActions } from '@/store/tariffSlice'
import { useMemo } from 'react'
import { notificationsActions } from '@/store/notificationsSlice'
import { profileActions } from '@/store/profileSlice'
import { creativesActions } from '@/store/creativesSlice'
import { dashboardActions } from '@/store/dashboardSlice'
import { favoritesActions } from '@/store/favorites'
import { filtersActions } from '@/store/filtersSlice'
import { appsActions } from '@/store/appsSlice'
import { adsActions } from '@/store/adsSlice'
import { adsClassicActions } from '@/store/adsClassicSlice'

const allActions = {
  ...tariffActions,
  ...notificationsActions,
  ...profileActions,
  ...creativesActions,
  ...favoritesActions,
  ...dashboardActions,
  ...filtersActions,
  ...appsActions,
  ...adsActions,
  ...adsClassicActions,
}

export const useActions = () => {
  const dispatch = useDispatch()
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch])
}
